import React, { useContext, useEffect, useMemo, useState } from "react";
import CheckListFBYInput from "../../../../../../blocks/FormItems/CheckListFBYInput";
import { Typography } from "antd";
import { spineOptions } from "../../../../Options/systemicExamOptions";
import { DoctorInitialContext } from "../../../HistoryForm/DoctorHistoryFormProvider";
const { Text } = Typography;
const Spine = ({ context, form }) => {
  const { formData } = useContext(context ? context : DoctorInitialContext);
  const spineData = formData?.systemic_examination || formData;
  const initialValues = useMemo(() => spineData, [formData]);
  const [checkboxes, setCheckboxes] = useState([]);

  useEffect(() => {
    const initialCheckboxes = spineOptions.reduce((acc, checkbox) => {
      acc[checkbox.value] = initialValues?.spine?.[checkbox.value] || false; // Initialize all checkboxes based on initialValues
      return acc;
    }, {});
    setCheckboxes(initialCheckboxes);
  }, [initialValues]);

  return (
    <>
      <Text>Spine</Text>
      <CheckListFBYInput
        options={spineOptions}
        checkboxes={checkboxes}
        setCheckboxes={setCheckboxes}
        others_key={"others"}
        keyChain={"spine"}
        form={form}
        field_key={["spine", "others"]}
      />
    </>
  );
};

export default Spine;
